<template>
  <div class="pagination">
    <!-- <a href="javascript:;" @click="pageTurn(0)" class="first_last" v-if="paging.index > 0">首页</a> -->
    <a href="javascript:;" @click="pageTurn(paging.index - 1)" class="first_last" v-if="paging.index > 0">上一页</a>
    <template v-for="i in sum">
      <a href="javascript:;" @click="pageTurn(i - 1)" :key="i" v-if="showText(i)" v-text="showText(i)"
        :class="i === paging.index + 1 ? 'active' : 'page'">
      </a>
    </template>
    <a href="javascript:;" @click="pageTurn(paging.index + 1)" class="first_last" v-if="paging.index < sum - 1">下一页</a>
    <!-- <a href="javascript:;" @click="pageTurn(sum - 1)" class="first_last" v-if="paging.index < sum - 1">末页</a> -->
  </div>
</template>
<script>
export default {
  props: ["sumCount", "perCount"],
  data() {
    return {
      paging: {
        index: 0, // index记录当前页码
        count: 9, // count表示每页多少条记录
      },
    };
  },
  computed: {
    sum() {
      // sum表示共有多少页
      return Math.ceil(this.sumCount / this.perCount);
    },
  },
  methods: {
    // 页码显示（有省略号）
    showText(i) {
      const vm = this;
      const index = vm.paging.index;
      const sum = vm.sum;
      if (i < 3 || i > sum - 2) {
        // 前两个和最后两个始终显示
        return i;
      } else if (i <= index + 2 && i >= index) {
        // 当前页的前一页和后一页始终显示
        return i;
      } else if (i === index + 3 || i === index - 1) {
        // 当前页的前前页和后后页显示 ...
        return "...";
      } // 除此之外都不显示
      return false;
    },
    // 翻页
    pageTurn(i) {
      const vm = this;
      if (i < 0 || i >= vm.sum || i === vm.paging.index) {
        return;
      }
      // vm.paging.index = i
  		vm.paging.index = i;
      // 告诉父组件翻页了，让父组件自己调用init
      vm.$emit("pageTurn", i, vm.perCount);
    },
  },
};
</script>
<style lang="less" scoped>
.pagination {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 30px;
}

.pagination .first_last {
  line-height: 34px;
  margin: 0 7px;
}

.pagination .page {
  width: 36px;
  height: 36px;
  border: 1px solid #969696;
  line-height: 34px;
  text-align: center;
  color: #040404 ;
  margin: 0 10px;
  font-size: 14px;
  background-color: #fff;
  border-radius: 8px;
}
.first_last{
  height: 36px;
  border: 1px solid #969696;
  line-height: 34px;
  text-align: center;
  color: #040404 ;
  font-size: 14px;
  background-color: #fff;
  border-radius: 8px;
  padding: 0 10px;
}
.pagination a.active {
  width: 36px;
  height: 36px;
  border: 1px solid #3D7EFE;
  line-height: 34px;
  text-align: center;
  color: #fff;
  margin: 0 10px;
  font-size: 14px;
  background-color: #3D7EFE;
}

.pagination a.page:hover,
.pagination a.active {
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  background-color: #3D7EFE;
  border-color: #3D7EFE;
}
.first_last:hover{
  color: #fff;
  background-color: #3D7EFE;
  border-color: #3D7EFE;
}
</style>
